import { atom as t } from "jotai";
const n = t(null), r = t(null), m = t(2), u = t(0), i = t(""), p = t(null, (o, l) => {
  l(n, null), l(r, null), l(A, null);
}), C = t((o) => {
  const l = o(n), e = o(r);
  if (!l || !e)
    return null;
  const a = o(m), s = o(u), c = o(i);
  return { arrivalDate: l, departureDate: e, totalAdults: a, totalChildren: s, promoCode: c };
}), D = t((o) => !!(o(n) && o(r))), h = t(!1), A = t(null);
export {
  n as arrivalDateAtom,
  r as departureDateAtom,
  D as isCompleteSearchAtom,
  h as isEditSearchAtom,
  i as promoCodeAtom,
  p as resetDatesAtom,
  A as restrictedDateClickedAtom,
  C as searchCriteriaAtom,
  m as totalAdultsAtom,
  u as totalChildrenAtom
};
